import getBestProducts, { ResGetBestProducts } from '@/service/market/best/getBestProducts';
import { useQuery } from '@tanstack/react-query';
import { RQBestKey } from './RQBestKey';

const useBestProductsHomeQuery = () => {
  return useQuery<
    ResGetBestProducts,
    object,
    ResGetBestProducts['result']['content'],
    (typeof RQBestKey)['bestHomeProducts']
  >({
    queryKey: RQBestKey['bestHomeProducts'],
    queryFn: () => getBestProducts({ query: {} }),
    select: (data) => {
      return data.result.content.slice(0, 8);
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useBestProductsHomeQuery;
